import reducers from "./UserReducers";

export { addUser, user_logout } from "./UserActions";

export default reducers;
